import { createContext, useContext, useEffect, useState } from 'react';

const NavContext = createContext(null);

const STORAGE_KEY = 'nav-collapsed';

export function NavProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(isCollapsed));
    } catch {
      // ignore storage errors
    }
    document.documentElement.style.setProperty('--nav-width', isCollapsed ? '4rem' : '14rem');
  }, [isCollapsed]);

  const toggleCollapsed = () => setIsCollapsed((value) => !value);

  return (
    <NavContext.Provider
      value={{
        isCollapsed,
        toggleCollapsed,
        isMobileMenuOpen,
        setIsMobileMenuOpen
      }}
    >
      {children}
    </NavContext.Provider>
  );
}

export function useNav() {
  const context = useContext(NavContext);
  if (!context) {
    throw new Error('useNav must be used within NavProvider');
  }
  return context;
}

export const mainContentClassName =
  'relative min-h-screen lg:ml-[var(--nav-width,14rem)] p-4 sm:p-6 lg:pr-8 lg:py-8 pt-16 lg:pt-8 transition-[margin-left] duration-300 ease-in-out';
